function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DateThead from './dateTHead.js';
import DateTbody from './dateTBody';
var __vue_script__ = {
  name: 'DateTable',
  components: {
    DateThead: DateThead,
    DateTbody: DateTbody
  },
  props: {
    prefixCls: {
      type: String,
      default: undefined
    },
    value: {
      type: Date,
      default: undefined
    },
    selectedValue: {
      type: [Date, Array],
      default: undefined
    },
    locale: {
      type: Object,
      default: undefined
    },
    format: {
      type: String,
      default: undefined
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    },
    rangeValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hoverValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    dateRender: {
      type: Function,
      default: null
    },
    contentRender: {
      type: Function,
      default: null
    }
  },
  computed: {
    normlizeLocale: function normlizeLocale() {
      var _this$locale = this.locale,
          locale = _this$locale === void 0 ? {} : _this$locale;
      return _objectSpread({
        WeekLocale: {
          // default zh_CN
          weekStartsOn: 1,

          /* Monday */
          firstWeekContainsDate: 4
        }
      }, locale);
    }
  },
  methods: {
    onSelect: function onSelect(value) {
      this.$emit('on-select', value);
      this.$emit('select', value);
    },
    onDayHover: function onDayHover(value) {
      this.$emit('on-day-hover', value);
      this.$emit('day-hover', value);
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('table', {
    class: _vm.prefixCls + "-table",
    attrs: {
      "cellSpacing": "0",
      "role": "grid"
    }
  }, [_c('date-thead', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "value": _vm.value,
      "selected-value": _vm.selectedValue,
      "locale": _vm.normlizeLocale,
      "show-week-number": _vm.showWeekNumber
    }
  }), _vm._v(" "), _c('date-tbody', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "value": _vm.value,
      "selected-value": _vm.selectedValue,
      "locale": _vm.normlizeLocale,
      "format": _vm.format,
      "range-values": _vm.rangeValues,
      "hover-values": _vm.hoverValues,
      "disabled-date": _vm.disabledDate,
      "date-render": _vm.dateRender,
      "content-render": _vm.contentRender,
      "show-week-number": _vm.showWeekNumber
    },
    on: {
      "on-day-hover": _vm.onDayHover,
      "on-select": _vm.onSelect
    }
  })], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "dateTable.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);